import { getDomainWhitelabelConfig } from '../auth/hooks/useWhitelabel/useWhitelabel';
import type { WhitelabelDocsConfig } from './types';

/**
 * Non-hook lookup of the current whitelabel's docs config based on the
 * current domain. Safe to call at module scope / pre-login.
 */
export const getPublicDocsConfig = (): WhitelabelDocsConfig | undefined =>
  getDomainWhitelabelConfig()?.docs;
